export const isFellowFarmer = () => {
  return process.env.REACT_APP_NAME === 'fellow.farmer';
};

export const isGardsbudet = () => {
  return process.env.REACT_APP_NAME === 'gardsbudet';
};


